import { createStore, createLogger } from 'vuex';
import dispatchActionForAllModules from '@/utils/dispatch-action-for-all-modules';

import modules from './modules';

const debug = process.env.NODE_ENV !== 'production';

const store = createStore({
  state: {},
  mutations: {}, 
  modules,
  actions: {
    reset() {
      dispatchActionForAllModules('reset');
    },
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});


// run the `init` action for every module if one exists.
export default store;
dispatchActionForAllModules('init');
